const pl = require("./language_json/pl.json");

export default pl;
